var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswerMissed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "answer_missed_svg__answer-missed",
    transform: "translate(16050 5125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "answer_missed_svg__check_circle_FILL1_wght400_GRAD0_opsz24",
    d: "M14,26a11.679,11.679,0,0,1-4.68-.946A11.974,11.974,0,0,1,2.946,18.68,11.679,11.679,0,0,1,2,14a11.679,11.679,0,0,1,.946-4.68A11.981,11.981,0,0,1,9.32,2.944,11.691,11.691,0,0,1,14,2a11.691,11.691,0,0,1,4.68.944A11.981,11.981,0,0,1,25.054,9.32,11.679,11.679,0,0,1,26,14a11.679,11.679,0,0,1-.946,4.68,11.974,11.974,0,0,1-6.374,6.374A11.679,11.679,0,0,1,14,26Z",
    transform: "translate(-16052 -5127)",
    fill: "#f0c000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "answer_missed_svg__Line_168",
    "data-name": "Line 168",
    d: "M10,1.25H0v-2.5H10Z",
    transform: "translate(-16043 -5112.75)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerMissed);
export default __webpack_public_path__ + "static/media/answer_missed.5489f22b606fb92062f889ad38108327.svg";
export { ForwardRef as ReactComponent };